import { FC } from "react";
import cn from "classnames";
import { useCardContext } from "../card-context";

export interface CardHeaderProps {
  className?: string;
}

const CardHeader: FC<CardHeaderProps> = ({ children }) => {
  const { getBemBlocksWith } = useCardContext();

  return (
    <div className={cn(getBemBlocksWith("__header"))} data-auto="card-header">
      {children}
    </div>
  );
};

export default CardHeader;
